import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a7dcbd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "newFactorValueModalRef",
  id: "kt_modal_new_ive_value",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_ive_value_header"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_ive_value_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_ive_value_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_ive_value_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_11 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = { class: "text-gray-800 fw-bolder" }
const _hoisted_14 = { class: "fs-6 text-gray-600" }
const _hoisted_15 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_16 = { class: "d-flex align-items-center fs-5 fw-bold mb-2" }
const _hoisted_17 = { class: "required" }
const _hoisted_18 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_19 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "modal-footer flex-center" }
const _hoisted_23 = {
  type: "reset",
  "data-bs-dismiss": "modal",
  id: "kt_modal_new_ive_value_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = { class: "indicator-progress" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_ive_value_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(({ handleReset }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(`${_ctx.translate('addNewIveValue')} - ${
                  _ctx.selectedArea.areaName
                } - ${_ctx.factorTitle}`), 1),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                "data-bs-dismiss": "modal",
                onClick: handleReset
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ], 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (!_ctx.selectedOption)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.translate('note')), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.translate('noFactorOptionsLeft')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('factorOption')), 1)
                  ]),
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.selectedOption,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
                    searchable: true,
                    required: true,
                    canDeselect: false,
                    options: _ctx.factorOptions,
                    label: "title",
                    trackBy: "title",
                    valueProp: "id",
                    placeholder: _ctx.translate('selectFactorOptions'),
                    noResultsText: _ctx.translate('noResultsFound')
                  }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate('value')), 1),
                  _createVNode(_component_Field, {
                    type: "number",
                    autocomplete: "off",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.translate('factorOptionIve'),
                    name: "value"
                  }, null, 8, ["placeholder"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "value" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                disabled: _ctx.selectedOption === null,
                ref: "submitButtonRef",
                type: "submit",
                id: "kt_modal_new_ive_value_submit",
                class: "btn btn-primary"
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_27
                ])
              ], 8, _hoisted_24)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}